export default {"src":"/_next/static/media/atmedia-logo.f99e4b65.svg","height":100,"width":301};